import React from 'react';
import { usePermissions } from '../permissions/usePermissions';
import InsufficientPermissionPage from './InsufficientPermissionPage';

export default function RequireReadPermission({ resource, children }) {
  const { canRead } = usePermissions();

  if (!canRead(resource)) {
    return <InsufficientPermissionPage />;
  }

  return children;
}
